module.exports = __webpack_public_path__ + "img/37.3f85680b.jpg";